<div class="result-modal meraki-modal">
  <!-- Close Button -->
  <button type="button" class="btn-close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>

  <!-- Success Header -->
  <div class="success-header">
    <div class="success-icon-wrapper">
      <mat-icon class="check-icon">check_circle</mat-icon>
    </div>
    <h2 class="title">Reports Generated</h2>
    <p class="subtitle">Your emission data is ready for review.</p>
  </div>

  <div class="report-links-container">
    <!-- Simple Report File (String URL) -->
    <ng-container *ngIf="isSimpleReport()">
      <div class="report-card primary-card">
        <div class="card-left">
          <mat-icon class="file-icon" [ngClass]="{ 'excel': !isPdfReport() }">
            {{ isPdfReport() ? 'picture_as_pdf' : 'assessment' }}
          </mat-icon>
          <div class="file-info">
            <span class="file-label">{{ getReportTitle() }}</span>
            <span class="file-type">{{ getFileTypeLabel() }}</span>
          </div>
        </div>
        <button
          *ngIf="isPdfReport()"
          type="button"
          class="btn-action btn-view"
          (click)="downloadFile(data?.report_file)">
          <mat-icon>visibility</mat-icon>
          <span>View PDF</span>
        </button>
        <button
          *ngIf="!isPdfReport()"
          type="button"
          class="btn-action btn-download"
          (click)="downloadFile(data?.report_file)">
          <mat-icon>download</mat-icon>
          <span>Download Report</span>
        </button>
      </div>
    </ng-container>

    <!-- Complex Report (Object with multiple links - CII) -->
    <ng-container *ngIf="!isSimpleReport()">
      <!-- CII PDF -->
      <div class="report-card primary-card">
        <div class="card-left">
          <mat-icon class="file-icon">picture_as_pdf</mat-icon>
          <div class="file-info">
            <span class="file-label">CII Report</span>
            <span class="file-type">PDF Document</span>
          </div>
        </div>
        <button class="btn-action btn-view" (click)="downloadFile(data?.report_file?.cii_pdf)">
          <mat-icon>visibility</mat-icon>
          <span>View PDF</span>
        </button>
      </div>

      <!-- Appendix 3 -->
      <div class="report-card">
        <div class="card-left">
          <mat-icon class="file-icon excel">description</mat-icon>
          <div class="file-info">
            <span class="file-label">Appendix 3</span>
            <span class="file-type">Excel Workbook</span>
          </div>
        </div>
        <button class="btn-action btn-download" (click)="downloadFile(data?.report_file?.appendix3)">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </button>
      </div>

      <!-- Final Report -->
      <div class="report-card">
        <div class="card-left">
          <mat-icon class="file-icon excel">assessment</mat-icon>
          <div class="file-info">
            <span class="file-label">Detailed Report</span>
            <span class="file-type">Final Analysis (XLSX)</span>
          </div>
        </div>
        <button class="btn-action btn-download" (click)="downloadFile(data?.report_file?.final_report)">
          <mat-icon>download</mat-icon>
          <span>Download</span>
        </button>
      </div>
    </ng-container>
  </div>

  <div class="footer-actions">
    <button class="btn-close-final" (click)="close()">Done</button>
  </div>
</div>